// Klient API Rynku zleceń `/api/v1/rynek/` (sesja w ciasteczku + CSRF, jak api/account.js).
import { apiFetch } from './apiFetch'

const BASE = process.env.REACT_APP_RYNEK_API_URL || '/api/v1/rynek'

const readCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(^|;\\s*)${name}=([^;]*)`))
  return m ? decodeURIComponent(m[2]) : null
}

const request = async (path, { method = 'GET', body } = {}) => {
  const headers = { 'Content-Type': 'application/json' }
  if (method !== 'GET') {
    const csrf = readCookie('csrftoken')
    if (csrf) headers['X-CSRFToken'] = csrf
  }
  let res
  try {
    res = await apiFetch(`${BASE}${path}`, {
      method, headers, credentials: 'same-origin', body: body ? JSON.stringify(body) : undefined,
    })
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem. Spróbuj ponownie.' }
  }
  let data = null
  try { data = await res.json() } catch { data = null }
  if (!res.ok) {
    return { ok: false, httpStatus: res.status, data, error: (data && data.detail) || 'Nie udało się wykonać operacji.' }
  }
  return { ok: true, data }
}

// Decyzja zmieniająca licznik na ikonie Rynku (F2): po udanym zapisie pasek doczytuje licznik (`nawigacja/LicznikRynku`).
const zLicznikiem = (obietnica) => obietnica.then((r) => {
  if (r.ok && typeof window !== 'undefined') window.dispatchEvent(new Event('vv-rynek-odswiez'))
  return r
})

// Kowalski
export const dodajOgloszenie = (dane) => request('/ogloszenia', { method: 'POST', body: dane })
export const mojeOgloszenia = () => request('/ogloszenia')
// Gość (decyzja właściciela 2026-10-26): zlecenie razem z kontem; body jak `dodajOgloszenie` plus `email`, `haslo`,
// `haslo2`, `zgoda_regulamin`, `zgoda_marketing`, bez `teczka_id`. 200 `{stan: 'czeka_na_email', email}`, 409 `kod:
// 'konto_istnieje'`, 400 `{detail, kod, pole}`, 429 `kod: 'limit_prob'`.
export const dodajOgloszenieZKontem = (dane) => request('/ogloszenia/z-kontem', { method: 'POST', body: dane })
// Nowy link „Potwierdź e-mail i opublikuj zlecenie” (z `?dalej=`) dla gościa i konta z niepotwierdzonym adresem:
// zawsze 200 `{ok: true}` (nie zdradza, czy konto istnieje), limity prób jako 429 `kod: 'limit_prob'`.
export const ponowPotwierdzenie = (email) => request('/ogloszenia/z-kontem/ponow', { method: 'POST', body: { email } })
export const mojeOgloszenie = (id) => request(`/ogloszenia/${id}`)
export const zamknijOgloszenie = (id) => zLicznikiem(request(`/ogloszenia/${id}/zamknij`, { method: 'POST' }))
export const wybierzOdpowiedz = (id) => request(`/odpowiedzi/${id}/wybierz`, { method: 'POST' })
export const udostepnijKontakt = (id) => request(`/odpowiedzi/${id}/kontakt`, { method: 'POST' })
export const odrzucOdpowiedz = (id) => request(`/odpowiedzi/${id}/odrzuc`, { method: 'POST' })
// Mini przetarg (2026-10-24): klient zaznacza firmy, które dostaną kontakt (id udziałów z `przetarg.uczestnicy`).
export const wybierzFirmy = (kod, udzialy) => zLicznikiem(request(`/ogloszenia/${kod}/wybierz-firmy`, { method: 'POST', body: { udzialy } }))
// Tryb dopasowania (2026-10-22): klient prosi firmę o koniec kontaktu.
// Umowa i montaż po wyborze (2026-11-03): `dane` = {etap: 'umowa'|'montaz'|'bez_umowy', data?, cofnij?}.
export const realizacjaKlienta = (kod, udostepnienieId, dane) => request(`/ogloszenia/${kod}/firmy/${udostepnienieId}/realizacja`, { method: 'POST', body: dane })
export const realizacjaFirmy = (kod, dane) => request(`/firma/ogloszenia/${kod}/realizacja`, { method: 'POST', body: dane })
export const koniecKontaktu = (kod, udostepnienieId) => request(`/ogloszenia/${kod}/firmy/${udostepnienieId}/koniec-kontaktu`, { method: 'POST' })

// Firma
export const ogloszeniaFirmy = () => request('/firma/ogloszenia')
export const ogloszenieFirmy = (id) => request(`/firma/ogloszenia/${id}`)
export const odpowiedzFirmy = (id, dane) => zLicznikiem(request(`/firma/ogloszenia/${id}/odpowiedz`, { method: 'PUT', body: dane }))
export const wycofajOdpowiedz = (id) => zLicznikiem(request(`/firma/ogloszenia/${id}/wycofaj`, { method: 'POST' }))
// Przetarg: `{ decyzja: 'tak' }` albo `{ decyzja: 'nie', powod, opis }`.
export const udzialFirmy = (id, dane) => zLicznikiem(request(`/firma/ogloszenia/${id}/udzial`, { method: 'POST', body: dane }))
// Profil firmy na Rynku (województwa, marki, specjalizacje, czas odpowiedzi): podstawa dopasowania.
// Licznik na ikonie Rynku w pasku (F2): firma zaproszenia do decyzji, klient zlecenia czekające na wybór.
export const licznikRynku = () => request('/licznik')
export const profilFirmy = () => request('/firma/profil')
// Nadzór Rynku (2026-11-04): wszystkie zlecenia, tylko dla konta właściciela; innym 404.
export const nadzorRynku = () => request('/nadzor')
// Zlecenie oczami firmy (nowej zaproszonej albo `firma` z zaproszeniem), bez zapisów i śladu u firmy.
export const nadzorZlecenie = (kod, firma) => request(`/nadzor/${kod}${firma ? `?firma=${encodeURIComponent(firma)}` : ''}`)
export const zapiszProfilFirmy = (dane) => request('/firma/profil', { method: 'PUT', body: dane })
